<template>
  <div>
    <gs-modal
      v-loading="loading"
      v-model="visible"
      :before-close="beforeClose"
      :before-confirm="beforeConfirm"
      title="环境健康指数"
      :has-form="true"
      class="time-event-dialog-modal"
      top="15%"
      width="600px"
      @close="close"
      @confirm="handleConfirm"
      append-to-body
    >
      <gs-form label-width="60px" label-position="left" gap="small">
        <gs-form-item label="名称" prop="name" class="form-item-radio">
          <gs-input ref="nameInput" v-model="name" />
        </gs-form-item>

        <gs-form-item label="描述" prop="description" class="form-item-radio">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="description"
          >
          </el-input>
        </gs-form-item>

        <gs-form-item label="设备" prop="target" class="form-item-radio">
          <div style="display: flex; align-items: center; gap: 10px">
            <gs-input v-model="fullName" readonly />
            <gs-button :disabled="isEdit" @click="getDataList('subDevice')"
              >...</gs-button
            >
          </div>
        </gs-form-item>
        <gs-form-item label="标签" prop="target" class="form-item-radio">
          <div
            style="padding: 6px 8px; border: 1px solid #7c7b7b"
            class="label-box"
          >
            <gs-form-item
              label="温度"
              prop="target"
              class="form-item-radio"
              label-width="40px"
            >
              <div style="display: flex; align-items: center; gap: 10px">
                <gs-input
                  v-model="temperatureName"
                  readonly
                  placeholder="请选择标签"
                />
                <gs-button
                  :disabled="isEdit"
                  @click="
                    openLabelManage();
                    labelType = 'temperature';
                  "
                  size="small"
                  >...</gs-button
                >
              </div>
            </gs-form-item>
            <gs-form-item
              label="湿度"
              prop="target"
              class="form-item-radio"
              label-width="40px"
            >
              <div style="display: flex; align-items: center; gap: 10px">
                <gs-input
                  v-model="humidityName"
                  readonly
                  placeholder="请选择标签"
                />
                <gs-button
                  :disabled="isEdit"
                  @click="
                    openLabelManage();
                    labelType = 'humidity';
                  "
                  size="small"
                  >...</gs-button
                >
              </div>
            </gs-form-item>
            <gs-form-item
              label="CO2"
              prop="target"
              class="form-item-radio"
              label-width="40px"
            >
              <div style="display: flex; align-items: center; gap: 10px">
                <gs-input
                  v-model="carbonName"
                  readonly
                  placeholder="请选择标签"
                />
                <gs-button
                  :disabled="isEdit"
                  @click="
                    openLabelManage();
                    labelType = 'carbon';
                  "
                  size="small"
                  >...</gs-button
                >
              </div>
            </gs-form-item>
            <gs-form-item
              label="TVOC"
              prop="target"
              class="form-item-radio"
              label-width="40px"
            >
              <div style="display: flex; align-items: center; gap: 10px">
                <gs-input
                  v-model="tvocName"
                  readonly
                  placeholder="请选择标签"
                />
                <gs-button
                  :disabled="isEdit"
                  @click="
                    openLabelManage();
                    labelType = 'tvoc';
                  "
                  size="small"
                  >...</gs-button
                >
              </div>
            </gs-form-item>
          </div>
        </gs-form-item>

        <gs-form-item label="间隔" class="form-item-radio">
          <gs-select
            style="width: 150px"
            v-model="cron"
            placeholder="请选择间隔"
          >
            <gs-option label="每半小时" :value="'0 0/30 * * * ?'"></gs-option>
            <gs-option label="每小时" :value="'0 0 */1 * * ?'"></gs-option>
          </gs-select>
        </gs-form-item>

        <gs-form-item label="结果" prop="target" class="form-item-radio">
          <div style="display: flex; align-items: center; gap: 10px">
            <gs-input v-model="resultName" readonly />
            <gs-button :disabled="isEdit" @click="getDataList('value_Analog')"
              >...</gs-button
            >
          </div>
        </gs-form-item>
      </gs-form>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm"
          >确 定</gs-button
        >
        <gs-button type="primary" size="mini" @click="beforeClose"
          >取 消</gs-button
        >
      </span>
    </gs-modal>
    <gs-modal
      v-model="visibleAdd"
      :before-close="beforeCloseAdd"
      class="my-test-class"
      title="请选择"
      @close="closeAdd"
      @confirm="handleConfirmAdd"
    >
      <div style="width: 100%; height: 500px">
        <gs-tree
          v-if="visibleAdd"
          ref="tree"
          :data="addList"
          :props="props"
          :disable-node="true"
          :leaf-checkbox-only="true"
          :node-key="'id'"
          show-checkbox
          @check-change="checkEvent"
        />
      </div>
    </gs-modal>

    <!-- 标签管理组件 -->
    <label-manage :data="labelData" @confirm="handleConfirmLabel" />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import service from "../../service/leftService.js";
import LabelManage from "./labelManage.vue";
import EventBus from "@/components/eventBus.js";
export default {
  components: {
    LabelManage,
  },
  data() {
    return {
      props: {
        label: "name",
        disabled: "type:folder",
      },
      visibleAdd: false,
      loading: false,
      name: "",

      description: "",

      isEdit: false,
      addList: [],
      objectSeries: [],
      resultId: "",
      resultName: "",
      label: "",
      statisType: "total",
      attribute: {
        min: "",
        max: "",
      },
      labelId: "",
      fullName: "",
      subDeviceId: "",
      temperatureName: "",
      humidityName: "",
      carbonName: "",
      tvocName: "",
      temperature: "",
      humidity: "",
      carbon: "",
      tvoc: "",
      labelData: [],
      labelType: "",
      treeType: "",
      cron: "",
    };
  },
  computed: {
    ...mapState({
      visible: "EHIShow",
      nodeData: "nodeTree",
      objectData: "objectInfo",
    }),
  },
  watch: {
    visible() {
      if (this.visible) {
        setTimeout(() => {
          this.$refs.nameInput.focus();
        }, 100);

        if (
          this.objectData &&
          JSON.stringify(this.objectData) !== "{}" &&
          this.objectData.type === "environmentScore"
        ) {
          service.getNode(this.objectData.id).then((res) => {
            this.isEdit = true;
            this.name = res.name;
            this.description = res.description;
            this.fullName = res.attribute.fullName;
            this.subDeviceId = res.attribute.subDeviceId;
            this.temperatureName = res.attribute.labelIds.temperatureName;
            this.temperature = res.attribute.labelIds.temperature;
            this.humidityName = res.attribute.labelIds.humidityName;
            this.humidity = res.attribute.labelIds.humidity;
            this.carbonName = res.attribute.labelIds.carbonName;
            this.carbon = res.attribute.labelIds.carbon;
            this.tvocName = res.attribute.labelIds.tvocName;
            this.tvoc = res.attribute.labelIds.tvoc;
            this.resultName = res.attribute.resultName;
            this.resultId = res.attribute.resultId;
            this.cron = res.attribute.cron;
          });
        } else {
          this.isEdit = false;

          this.attribute = {};
          this.resultName = "";
          this.resultId = "";

          this.description = "";
          this.name = "";
          this.objectSeries = [];

          this.fullName = "";
          this.subDeviceId = "";
          this.temperatureName = "";
          this.temperature = "";
          this.humidityName = "";
          this.humidity = "";
          this.carbonName = "";
          this.carbon = "";
          this.tvocName = "";
          this.tvoc = "";
          this.resultName = "";
          this.resultId = "";
          this.cron = "";
        }
      } else {
        this.isEdit = true;

        this.description = "";
        this.name = "";
        this.objectSeries = [];

        this.fullName = "";
        this.subDeviceId = "";
        this.temperatureName = "";
        this.temperature = "";
        this.humidityName = "";
        this.humidity = "";
        this.carbonName = "";
        this.carbon = "";
        this.tvocName = "";
        this.tvoc = "";
        this.resultName = "";
        this.resultId = "";
        this.cron = "";
      }
    },
  },
  methods: {
    ...mapMutations({
      close: "EHI_HIDE",
      openLabelManage: "EHI_LABEL_MANAGE_SHOW",
    }),
    //主
    beforeClose() {
      this.close();
    },
    handleConfirm() {
      if (!this.name) {
        return this.$message.warning("请输入名称！");
      }
      if (!this.description) {
        return this.$message.warning("请输入描述！");
      }

      if (!this.fullName) {
        return this.$message.warning("请选择设备！");
      }
      if (!this.temperature || !this.humidity || !this.carbon || !this.tvoc) {
        return this.$message.warning("标签不能为空！");
      }

      if (!this.cron) {
        return this.$message.warning("请选择间隔！");
      }
      if (!this.resultId) {
        return this.$message.warning("请选择结果！");
      }

      let obj = {
        name: this.name,
        description: this.description,
        type: "environmentScore",
        parentId: this.nodeData.id,
        attribute: {
          jobName: 9,
          jobGroupName: this.nodeData.name,
          fullName: this.fullName,
          subDeviceId: this.subDeviceId,
          labelIds: {
            temperature: this.temperature,
            temperatureName: this.temperatureName,
            humidity: this.humidity,
            humidityName: this.humidityName,
            carbon: this.carbon,
            carbonName: this.carbonName,
            tvoc: this.tvoc,
            tvocName: this.tvocName,
          },
          cron: this.cron,
          resultId: this.resultId,
          resultName: this.resultName,
        },
      };
      if (this.isEdit) {
        obj.id = this.objectData.id;
        service
          .editPoint(obj)
          .then((res) => {
            this.$message.success("修改成功");
            this.close();
            EventBus.$emit("refresh");
          })
          .catch((err) => {
            this.$message.error("创建失败");
          });
      } else {
        service
          .newAddPoint(obj)
          .then((res) => {
            this.$message.success("创建成功");
            this.close();
            EventBus.$emit("refresh");
          })
          .catch((err) => {
            this.$message.error("创建失败");
          });
      }
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === "") {
        this.$Message.warning("名称不能为空!");
        return;
      }
      done();
    },

    delObjectSeriesArray(val) {
      this.objectSeries.forEach((value, index, array) => {
        if (val.name === value.name) {
          this.objectSeries.splice(index, 1);
        }
      });
    },
    beforeCloseAdd() {
      this.visibleAdd = false;
    },
    checkEvent(node, isSelect, halfSelect) {
      switch (node.type) {
        case "value_Analog":
          this.singleChoice(node.id);
          break;
        case "subDevice":
          this.singleChoice(node.id);
          break;

        default:
          this.$Message.error("此节点为目录，无法被选择");
          this.$refs.tree.setChecked(node.id, false);
          break;
      }
    },

    // 单选操作
    singleChoice(id) {
      let leafCheckArr = this.$refs.tree.getCheckedKeys();
      if (leafCheckArr.length > 1) {
        leafCheckArr.forEach((item) => {
          if (item != id) {
            this.$refs.tree.setChecked(item, false);
          }
        });
      }
    },
    handleConfirmAdd() {
      this.$refs.tree.getCheckedNodes(true).forEach((e) => {
        this.objectSeries = [e.data];
      });

      console.log(this.objectSeries);
      if (this.objectSeries.length > 0) {
        if (this.treeType === "value_Analog") {
          this.resultId = this.objectSeries[0].id;
          this.resultName = this.objectSeries[0].fullName;
        } else {
          this.subDeviceId = this.objectSeries[0].id;
          this.fullName = this.objectSeries[0].fullName;
        }
      }
      this.visibleAdd = false;
    },
    unique(arr, name) {
      var hash = {};
      return arr.reduce(function (item, next) {
        hash[next[name]] ? "" : (hash[next[name]] = true && item.push(next));
        return item;
      }, []);
    },
    closeAdd() {
      this.visibleAdd = false;
    },

    getDataList(type) {
      let _this = this;
      _this.addList = [];
      this.visibleAdd = true;
      this.treeType = type;
      service.getRightList(this.nodeData.id).then((res) => {
        _this.addList = res.filter((item) => item.type === type);
      });
    },
    handleConfirmLabel(label) {
      if (label) {
        if (this.labelType === "temperature") {
          this.temperatureName = label[0].name;
          this.temperature = label[0].id;
        } else if (this.labelType === "humidity") {
          this.humidityName = label[0].name;
          this.humidity = label[0].id;
        } else if (this.labelType === "carbon") {
          this.carbonName = label[0].name;
          this.carbon = label[0].id;
        } else if (this.labelType === "tvoc") {
          this.tvocName = label[0].name;
          this.tvoc = label[0].id;
        }
      }
    },
  },
};
</script>
<style>
/* .gs-form-item {
  margin-bottom: 0px !important;
} */
</style>
<style scoped>
.addTree {
  cursor: pointer;
  color: rgb(248, 121, 1);
}

.inp >>> .gs-input,
.gs-input-number {
  height: 26px;
}

.gs-modal-wrap {
  top: 11%;
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 45%;
  float: left;
  margin-right: 20px;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.seventy-part {
  box-sizing: border-box;
  float: left;
  width: 65%;
}

.thirty-part {
  box-sizing: border-box;
  float: left;
  width: 100%;
}

.event-btn {
  margin: 10px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 47%;
  float: left;
  margin-right: 13px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.form-item-objectSeries {
  height: 250px;
  overflow: auto;
  margin-bottom: 12px;
  padding: 12px;
  border: solid 1px #d9d9d9;
  border-radius: 1px;
}

.form-item-objectSeries >>> .gs-form-item {
  margin-bottom: 0px m !important;
}

.label-box .gs-button-small {
  height: 20px;
  padding: 0 20px;
}
/deep/ .label-box .gs-form-item-label {
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/EHI/Index.vue